import { CommonModule } from '@angular/common'
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core'
import { TranslateModule } from '@ngx-translate/core'
import { ApiService } from 'app/services/api.service'

export interface BannerData {
    giftKey: string // Clave para ngx-translate (ej. 'Apple Watch')
    imageName: string // Nombre del archivo de imagen (ej. 'AppleWatch.png')
    salesElite: number
    salesPremium: number
}

// Define la URL base de tus imágenes
export const BANNER_IMAGE_BASE_URL = 'https://assetsstatic.cosentino.com/ImagesCommunityCosentinoWe/actios/banner/'

/**
 * Mapa de configuración del banner por país.
 * La clave es el código ISO 3166-1 alpha-2 (ISO code 2) en MAYÚSCULAS.
 */
export const BANNER_DATA_MAP: Record<string, BannerData> = {
    GB: { giftKey: 'Apple Watch', imageName: 'AppleWatch.png', salesElite: 17, salesPremium: 11 }, // Reino Unido
    ES: { giftKey: 'Apple Watch', imageName: 'AppleWatch.png', salesElite: 15, salesPremium: 10 }, // España
    PT: { giftKey: 'Apple Watch', imageName: 'AppleWatch.png', salesElite: 19, salesPremium: 13 }, // Portugal
    DE: { giftKey: 'Apple Watch', imageName: 'AppleWatch.png', salesElite: 17, salesPremium: 11 }, // Alemania
    AT: { giftKey: 'Apple Watch', imageName: 'AppleWatch.png', salesElite: 16, salesPremium: 11 }, // Austria
    AE: { giftKey: 'Apple Watch', imageName: 'AppleWatch.png', salesElite: 16, salesPremium: 11 }, // Emiratos Arabes
    SE: { giftKey: 'Apple Watch', imageName: 'AppleWatch.png', salesElite: 17, salesPremium: 12 }, // Suecia
    DK: { giftKey: 'Apple Watch', imageName: 'AppleWatch.png', salesElite: 16, salesPremium: 11 }, // Dinamarca
    NO: { giftKey: 'Apple Watch', imageName: 'AppleWatch.png', salesElite: 15, salesPremium: 10 }, // Noruega
    NZ: { giftKey: 'Apple Watch', imageName: 'AppleWatch.png', salesElite: 16, salesPremium: 11 }, // Nueva Zelanda
    US: { giftKey: 'Apple Watch', imageName: 'AppleWatch.png', salesElite: 15, salesPremium: 10 }, // Estados Unidos
    CA: { giftKey: 'Apple Watch', imageName: 'AppleWatch.png', salesElite: 12, salesPremium: 10 }, // Canadá
    SK: { giftKey: 'Apple Watch', imageName: 'AppleWatch.png', salesElite: 19, salesPremium: 12 }, // Eslovaquia
    EE: { giftKey: 'Apple Watch', imageName: 'AppleWatch.png', salesElite: 13, salesPremium: 9 }, // Estonia
    FI: { giftKey: 'Apple Watch', imageName: 'AppleWatch.png', salesElite: 12, salesPremium: 8 }, // Finlandia
    FR: { giftKey: 'Apple Watch', imageName: 'AppleWatch.png', salesElite: 18, salesPremium: 12 }, // Francia
    HU: { giftKey: 'Apple Watch', imageName: 'AppleWatch.png', salesElite: 18, salesPremium: 12 }, // Hungría
    IE: { giftKey: 'Apple Watch', imageName: 'AppleWatch.png', salesElite: 15, salesPremium: 10 }, // Ireland
    IT: { giftKey: 'Apple Watch', imageName: 'AppleWatch.png', salesElite: 19, salesPremium: 13 }, // Italia
    LV: { giftKey: 'Apple Watch', imageName: 'AppleWatch.png', salesElite: 15, salesPremium: 8 }, // Letonia
    LT: { giftKey: 'Apple Watch', imageName: 'AppleWatch.png', salesElite: 13, salesPremium: 9 }, // Lituania
    LU: { giftKey: 'Apple Watch', imageName: 'AppleWatch.png', salesElite: 17, salesPremium: 12 }, // Luxemburgo
    MC: { giftKey: 'Apple Watch', imageName: 'AppleWatch.png', salesElite: 18, salesPremium: 12 }, // Mónaco
    NL: { giftKey: 'Apple Watch', imageName: 'AppleWatch.png', salesElite: 16, salesPremium: 11 }, // Países bajos
    PL: { giftKey: 'Apple Watch', imageName: 'AppleWatch.png', salesElite: 18, salesPremium: 12 }, // Polonia
    CZ: { giftKey: 'Apple Watch', imageName: 'AppleWatch.png', salesElite: 16, salesPremium: 11 }, // Republica Checa
    BE: { giftKey: 'Apple Watch', imageName: 'AppleWatch.png', salesElite: 17, salesPremium: 12 }, // Bélgica
    SG: { giftKey: 'Apple Watch', imageName: 'AppleWatch.png', salesElite: 13, salesPremium: 9 }, // Singapur
    CH: { giftKey: 'Apple Watch', imageName: 'AppleWatch.png', salesElite: 16, salesPremium: 9 }, // Suiza
    MY: { giftKey: 'Apple Watch', imageName: 'AppleWatch.png', salesElite: 15, salesPremium: 10 }, // Malasia
    MX: { giftKey: 'Airpods 3', imageName: 'Airpods3.png', salesElite: 14, salesPremium: 10 }, // México
    ZA: { giftKey: 'Airpods 3', imageName: 'Airpods3.png', salesElite: 11, salesPremium: 8 }, // Sudáfrica
    AU: { giftKey: 'Airpods 2', imageName: 'Airpods2.png', salesElite: 11, salesPremium: 8 }, // Australia
    AR: { giftKey: 'Airpods 2', imageName: 'Airpods2.png', salesElite: 18, salesPremium: 12 }, // Argentina
    CL: { giftKey: 'Oster Fryer', imageName: 'Freidora.png', salesElite: 7, salesPremium: 5 }, // Chile
    CO: { giftKey: 'Takdir Robot', imageName: 'RobotAspirador.png', salesElite: 8, salesPremium: 6 }, // Colombia
}

@Component({
    selector: 'app-dynamic-banner',
    templateUrl: './dynamic-banner.component.html',
    imports: [TranslateModule,CommonModule],
    standalone: true,
})
export class DynamicBannerComponent {

    constructor(private api: ApiService) {}

    public showBanner: boolean = false
    public country: string | null = null
    public loyaltyLevel: null | string = '' 
    public imageUrl: string | null = null
    public gift: string = ''
    public level: string = ''
    public requiredSales: number | null = null
    private imageBaseUrl = BANNER_IMAGE_BASE_URL
    ngOnInit(): void {
        console.log('hellooou')
        this.api.userInfo.subscribe((userInfo) => {
            if (userInfo.loyaltyLevel && userInfo.country)
                this.country = userInfo.country
                this.loyaltyLevel = userInfo.loyaltyLevel
                console.log(this.country,userInfo.loyaltyLevel)
                this.updateBannerData()
            })
        }

    private updateBannerData(): void {
        // Aseguramos que el país (ISO code) esté en mayúsculas para la búsqueda.
        const countryCode = this.country ? this.country.toUpperCase() : ''
        const normalizedLevel = this.loyaltyLevel ? this.loyaltyLevel.toLowerCase() : ''

        // Buscamos directamente en el mapa con el código ISO
        const data: BannerData = BANNER_DATA_MAP[countryCode]

        // Si no hay datos para ese país, ocultar
        if (!data) {
            console.log(`No banner data for country code: ${countryCode}`)
            this.showBanner = false
            return
        }

        let sales: number | null = null
        let levelKey: string | null = null

        if (normalizedLevel === 'elite') {
            sales = data.salesElite
            levelKey = 'LOYALTY.ELITE'
        } else if (normalizedLevel === 'premium') {
            sales = data.salesPremium
            levelKey = 'LOYALTY.PREMIUM'
        }

        // Si el nivel no es válido, ocultar
        if (sales === null || levelKey === null) {
            this.showBanner = false
            return
        }

        // ¡Datos listos! Exponer a la plantilla
        this.imageUrl = `${this.imageBaseUrl}${data.imageName}`
        this.gift = data.giftKey
        this.requiredSales = sales
        this.showBanner = true
    }
}
